/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Embedding
 */
export interface Embedding {
    /**
     * 
     * @type {Array<number>}
     * @memberof Embedding
     */
    embedding: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof Embedding
     */
    index: number;
    /**
     * 
     * @type {string}
     * @memberof Embedding
     */
    object: string;
}

/**
 * Check if a given object implements the Embedding interface.
 */
export function instanceOfEmbedding(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "embedding" in value;
    isInstance = isInstance && "index" in value;
    isInstance = isInstance && "object" in value;

    return isInstance;
}

export function EmbeddingFromJSON(json: any): Embedding {
    return EmbeddingFromJSONTyped(json, false);
}

export function EmbeddingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Embedding {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'embedding': json['embedding'],
        'index': json['index'],
        'object': json['object'],
    };
}

export function EmbeddingToJSON(value?: Embedding | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'embedding': value.embedding,
        'index': value.index,
        'object': value.object,
    };
}

